/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useState, useEffect } from 'react';
import { useQuery } from 'react-apollo';

import type {
	useLabelsLabelCountQuery as useLabelsLabelCountQuery$data,
	useLabelsLabelCountQueryVariables as useLabelsLabelCountQuery$variables,
} from './__types__/useLabelsLabelCountQuery';

export const useLabels = (contentId: string) => {
	const [hasLabels, setHasLabels] = useState<boolean>(true);

	const { data } = useQuery<useLabelsLabelCountQuery$data, useLabelsLabelCountQuery$variables>(
		gql`
			query useLabelsLabelCountQuery($contentId: ID!) {
				content(id: $contentId, status: ["current", "draft"]) {
					nodes {
						id
						labels(orderBy: { sortField: LABELLING_CREATIONDATE, direction: ASCENDING }) {
							count
						}
					}
				}
			}
		`,
		{
			variables: { contentId },
		},
	);

	useEffect(() => {
		setHasLabels((data?.content?.nodes?.[0]?.labels?.count ?? 0) > 0);
	}, [data]);

	return hasLabels;
};
